document.addEventListener('DOMContentLoaded', () => {
    const today = new Date();
    const endDay = new Date(2022, 4, 2); // May 2, 2022

    if (today < endDay) {
        if(!localStorage.getItem('rmd-popup')) {
            setTimeout(() => showPopup(), 2000);
        }
    } else {
        if (localStorage.getItem('rmd-popup')) {
            localStorage.removeItem('rmd-popup');
        }
    }


    /**
     * Create a popup for Ramadan holiday
     * @return {Node} The template HTML
     */
    function showPopup() {
        const popup = document.createElement('div');
        popup.className = 'rmd-popup';

        const image = document.createElement('img');
        image.className = 'rmd-popup-img';
        image.src="/wp-content/themes/capitalixau/assets/img/ramadan-logo.svg";
        image.alt="Ramadan kareem"

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'rmd-popup-close';
        close.addEventListener('click', () => {
            popup.classList.add('rmd-popup--closed');
            setTimeout(() => popup.remove(), 2000);
        });

        popup.append(image, close);
        document.body.append(popup);
        localStorage.setItem('rmd-popup', 'opened');
    }
});
